<template>
    <div>
        <form-input v-model="data.name"
                    :rules="{max: 100, min: 2, required: required}"
                    :disabled="disabled"
                    :label="$t('label.full_name')"/>

        <form-input v-model="data.co_name"
                    :rules="{max: 100, min: 2}"
                    clearable
                    :disabled="disabled"
                    :label="$t('label.delivery_co_name')"/>

        <contact-form-inputs :data="data" slim disable-help :disabled="disabled" :required="required" :street-required="required"/>
    </div>
</template>

<script>

import {FormInputsMixin} from "@spoferan/nuxt-spoferan/mixins";;


export default {
    name: 'DeliveryDataFormInputs',
    mixins: [FormInputsMixin],

    props: {
        // Whether all inputs shall be disabled
        required: {
            type: Boolean,
            default: false
        },
    }

}
</script>